import { utils, writeFile } from "xlsx";
//Initialize After Login
export let serverUrl = localStorage.getItem("ServerUrl");
export function setServerUrl(url) {
    serverUrl = url;
}

export function getheader() {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Data-Type', 'json');
    myHeaders.append('token', localStorage.getItem('token'));
    const durationId = localStorage.getItem("DurationID");
    if (durationId) {
        myHeaders.append("durationid", durationId);
    }
    //window._header = myHeaders;
    return myHeaders;
}
export const invoiceTypes = {
    PrePurchase: "PrePurchase",
    Purchase: "Purchase",
    PreSale: "PreSale",
    Sale: "Sale",
    Borrow: "Borrow",
    Resid: "Resid",
    OldParts: "OldParts",
    ReturnFromPurchase: "ReturnFromPurchase",
    ReturnFromSale: "ReturnFromSale",
    ReturnFromBorrow: "ReturnFromBorrow",
    Transfer: "Transfer",
    Havaleh: "Havaleh",
    ServiceInvoice: "ServiceInvoice",
    Disassembly:"Disassembly"
}
export const invoiceTypesArray = [
    { TypeName: invoiceTypes.Transfer, TypeStr: "انتقال بین انبارها" },
    { TypeName: invoiceTypes.ReturnFromPurchase, TypeStr: "برگشت از خرید" },
    { TypeName: invoiceTypes.ReturnFromSale, TypeStr: "برگشت از فروش" },
    { TypeName: invoiceTypes.ReturnFromBorrow, TypeStr: "برگشت حواله به نماینده" },
    { TypeName: invoiceTypes.PrePurchase, TypeStr: "پیش فاکتور خرید" },
    { TypeName: invoiceTypes.PreSale, TypeStr: "پیش فاکتور فروش" },
    { TypeName: invoiceTypes.Havaleh, TypeStr: "حواله انبار" },
    { TypeName: invoiceTypes.Borrow, TypeStr: "حواله به نماینده/تکنسین" },
    { TypeName: invoiceTypes.Resid, TypeStr: "رسید انبار" },
    { TypeName: invoiceTypes.Purchase, TypeStr: "فاکتور خرید" },
    { TypeName: invoiceTypes.Sale, TypeStr: "فاکتور فروش" },
    { TypeName: invoiceTypes.ServiceInvoice, TypeStr: "فاکتور فروش کالا و خدمات" }

];
export const allAttachmentTypes = {
    "customer": "طرف حساب",
    "pre_customer": "مشتری بالقوه",
    "acc_doc": "سند حسابداری",
    "install": "سرویس نصب",
    "repair": "سرویس تعمیر",
    "Sale": "فاکتور فروش",
    "PreSale": "پیش فاکتور فروش",
    "Purchase": "فاکتور خرید",
    "PrePurchase": "پیش فاکتور خرید",
    "ReturnFromSale": "برگشت از فروش",
    "ReturnFromPurchase": "برگشت از خرید",
    "Borrow": "حواله به نماینده",
    "ReturnFromBorrow": "برگشت حواله نماینده",
    "OldParts": "در قبال داغی",
    "OutOfOrder": "فاکتور ضایعات",
    "Resid": "رسید انبار",
    "Havaleh": "حواله انبار",
    "Transfer": "انتقال بین انبارها",
    "staff": "نماینده/تکنسین/پرسنل",
    "": "عمومی",
    undefined:"عمومی"
}
export const invoiceStates = {
    Draft: 0,
    WatingForApprove: 1,
    Approved: 2,
    ConvertToInvoice: 3
}
export const chequeStatuses =
{
    White: "White",
    in_1_RecieveCheque: "in_1_RecieveCheque",
    in_2_PutInAccount: "in_2_PutInAccount",
    in_3_GiveToCustomer: "in_3_GiveToCustomer",
    in_4_Cash: "in_4_Cash",
    in_5_NotCash: "in_5_NotCash",
    in_6_ReturnAndCustomerPay: "in_6_ReturnAndCustomerPay",
    in_7_ReturnAndCustomerNotPay: "in_7_ReturnAndCustomerNotPay",
    in_8_CustomerReturns: "in_8_CustomerReturns",
    in_8_CustomerReturns_PrvDurations: "in_8_CustomerReturns_PrvDurations",
    out_1_PayCheque: "out_1_PayCheque",
    out_2_PassCheque: "out_2_PassCheque",
    out_3_CustomerReturns: "out_3_CustomerReturns"
}
export const pChequeStatuses =
{
    White: "سفید",
    in_1_RecieveCheque: "نزد صندوق",
    in_2_PutInAccount: "نزد بانک",
    in_3_GiveToCustomer: "واگذار شده",
    in_4_Cash: "وصول شده",
    in_5_NotCash: "وصول نشده",
    in_6_ReturnAndCustomerPay: "برگشتی واگذار شده",
    in_7_ReturnAndCustomerNotPay: "برگشتی واگذار نشده",
    in_8_CustomerReturns: "واگذار شده برگشتی",
    in_8_CustomerReturns_PrvDurations: "واگذار شده برگشتی دوره قبل",
    out_1_PayCheque: "نزد اشخاص",
    out_2_PassCheque: "پاس شده",
    out_3_CustomerReturns: "برگشتی"
}
export const chequeStatusArray = [
    { StatusName: chequeStatuses.White, StatusTitle: "سفید" },
    { StatusName: chequeStatuses.in_1_RecieveCheque, StatusTitle: "نزد صندوق" },
    { StatusName: chequeStatuses.in_2_PutInAccount, StatusTitle: "نزد بانک" },
    { StatusName: chequeStatuses.in_3_GiveToCustomer, StatusTitle: "واگذار شده" },
    { StatusName: chequeStatuses.in_4_Cash, StatusTitle: "وصول شده" },
    { StatusName: chequeStatuses.in_5_NotCash, StatusTitle: "وصول نشده" },
    { StatusName: chequeStatuses.in_6_ReturnAndCustomerPay, StatusTitle: "برگشتی واگذار شده" },
    { StatusName: chequeStatuses.in_7_ReturnAndCustomerNotPay, StatusTitle: "برگشتی واگذار نشده" },
    { StatusName: chequeStatuses.in_8_CustomerReturns, StatusTitle: "واگذار شده برگشتی" },
    { StatusName: chequeStatuses.out_1_PayCheque, StatusTitle: "نزد اشخاص" },
    { StatusName: chequeStatuses.out_2_PassCheque, StatusTitle: "پاس شده" },
    { StatusName: chequeStatuses.out_3_CustomerReturns, StatusTitle: "برگشتی" },

]
export const productRequestStatuses = {
    FeedBack: -1,
    InitRequest: 0,
    NotConfirmed: 1,
    Confirmed: 2,
    WaitingQueue: 3,
    ReadyToSend: 4,
    Sent: 5,
    Delivered: 6,
    Draft: 7,
    Checked: 8,
    Closed: 9
}
export const cacheTypes = {
    Default: "default",
    Force: "force-cache",
    NoCache: "no-cache",
    NoStore: "no-store",
    OnlyIfCached: "only-if-cached",
    Reload: "reload"
}
export const documentStatuses = {
    Draft: 0,
    Temp: 1,
    Permanet: 2
}
export const systemModules = {
    BaseInfo: 2,
    CRM: 4,
    Services: 8,
    Finances: 16,
    Office: 32,
    Sale: 64,
    Treasury: 128,
    StorageInvoice: 256,
    Production: 512,
    Salary: 1024,
    Projects: 2048,
    Agents: 4096,
    StaffApp: 8192,
    DocumentManagement: 16384,
    Commands: 32768,
    VIP_Customers: 65536,
    ServiceInvoice: 131072,
    WordPressLink: 68719476736,
    MainCompanyLink: 274877906944,
    MonitoringAndManagement: 262144,
    ProductDistributionManagement: 524288,
    GuaranteeCheck: 1048576,
    CustomersClub: 2097152,
    Assets: 4194304,
    HappyCall: 8388608,
    Complaints: 16777216,
    Transport: 33554432,
    TaxpayerSystem: 67108864,
    ReportGenerator: 134217728,
    WorkFlow: 268435456,
    PhoneCallsManagement: 536870912,
    SMSManagement: 1073741824,
    Reminders: 2147483648,
    PeriodicServices: 4294967296,
    EventsManagement: 8589934592,
    Awards: 17179869184,
    BarCode: 137438953472
}
export function translateError(message) {
    message = message.toLowerCase();
    if (message.includes("no http resource was found")) {
        return "تابع سمت سرور یافت نشد";
    }
    switch (message) {
        case "productnotfound":
            return "کالایی با این مشخصات یافت نشد";
        case "fillsearchfields":
            return "کادرهای جستجو پر نشده است";
        case "no access":
            return "دسترسی مجاز نیست!‏";
        case "duplicateserial":
            return "سریال وارد شده تکراری است یا کار تکمیل نشده ای برای این سریال وجود دارد";
        case "errormobile":
            return "کاربری با این شماره همراه در سیستم وجود دارد";
        case "errorphone":
            return "کاربری با این شماره تلفن در سیستم وجود دارد";
        case "errornationalcode":
            return "کابری با این شماره ملی در سیستم وجود دارد";
        case "success":
            return "عملیات با موفقیت انجام شد";
        case "failed to fetch":
            return "ارتباط با سرور برقرار نیست";
        case "no access":
            return "دسترسی مجاز نیست";
        case "an error has occurred":
        case "an error has occurred.":
            return "خطایی رخ داده است. از نرم افزار خارج شده دوباره وارد شوید."
        case "the request is invalid":
        case "the request is invalid.":
            return "درخواست ارسال شده به سرور معتبر نیست";
        case "":
        case "error":
        case undefined:
            return "اشکال در انجام عملیات";
        default:
            return message;
    }
}
export function setErrorDialog(dispatch, message, title) {
    let dialogData = {
        status: 'show',
        arrayBtn: ['ok'],
        dialogTitle: '',
        dialogText: ' '
    };
    dialogData.dialogTitle = title;
    if (!message) {
        message = "";
    }
    message = message.toLowerCase();
    switch (message) {
        case "productnotfound":
            dialogData.dialogText = "کالایی با این مشخصات یافت نشد";
            break;
        case "fillsearchfields":
            dialogData.dialogText = "کادرهای جستجو پر نشده است";
            break;
        case "no access":
            dialogData.dialogText = "دسترسی مجاز نیست!‏";
            break;
        case "duplicateserial":
            dialogData.dialogText = "سریال وارد شده تکراری است یا کار تکمیل نشده ای برای این سریال وجود دارد";
            break;
        case "errormobile":
            dialogData.dialogText = "کاربری با این شماره همراه در سیستم وجود دارد";
            break;
        case "errorphone":
            dialogData.dialogText = "کاربری با این شماره تلفن در سیستم وجود دارد";
            break;
        case "errornationalcode":
            dialogData.dialogText = "کابری با این شماره ملی در سیستم وجود دارد";
            break;
        case "success":
            dialogData.dialogText = "عملیات با موفقیت انجام شد";
            break;
        case "failed to fetch":
            dialogData.dialogText = "ارتباط با سرور برقرار نیست";
            break;
        case "draftstatusnotfound":
            dialogData.dialogText = "وضعیت پیش فرض درخواست در سیستم تعریف نشده است";
            break;
        case "nofound":
            dialogData.dialogText = "موردی برای حذف یافت نشد";
            break;
        case "isnotindraftstatus":
            dialogData.dialogText = "حذف تنها در وضعیت پیش نویس امکانپذیر است";
            break;
        case "notenoughentity":
            dialogData.dialogText = "موجودی برخی کالاها برای صدور فاکتور کافی نیست";
            break;
        case "staffisnull":
            dialogData.dialogText = "برای این درخواست تکنسینی ثبت نشده است";
            break;
        case "networkerror":
            dialogData.dialogText = "شبکه مشغول است";
            break;
        case "deletedbefore":
            dialogData.dialogText = "این سرویس پیش از این حذف شده است";
            break;
        case "storageisnotvalid":
            dialogData.dialogText = "برای این نماینده/تکنسین انباری تعریف نشده است";
            break;
        case "negativecountinstoragenotallowed":
            dialogData.dialogText = "موجودی کالا برای ثبت در قطعات سرویس کافی نیست";
            break;
        case "hascustomer":
            dialogData.dialogText = "حداقل یک مشتری با این وضعیت در سیستم ثبت شده است";
            break;
        case "an error has occurred":
        case "an error has occurred.":
            dialogData.dialogText = "خطایی رخ داده است. از نرم افزار خارج شده دوباره وارد شوید.";
            break;
        case "the request is invalid":
        case "the request is invalid.":
            dialogData.dialogText = "درخواست ارسال شده به سرور معتبر نیست";
            break;
        case "":
        case "error":
        case undefined:
            dialogData.dialogText = "اشکال در انجام عملیات";
            break;
        default:
            if (message.includes("no http resource was found")) {
                dialogData.dialogText = "تابع سمت سرور یافت نشد";
            }
            else {
                dialogData.dialogText = message;
            }

    }
    dispatch({
        type: "SET_DIALOG",
        data: dialogData
    });
}
export function setDialog(status) {
    return dispatch => {
        return dispatch({
            type: "SET_DIALOG",
            data: status
        });
    }
}
export function getExcelTemplates(formName, fn) {
    fetch(serverUrl + "api/ExcelTemplateAPI/GetTemplates?formName=" + formName, {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (!res.Message) {
                if (fn) {
                    fn(res);
                }
            }
        }).catch(e => console.log("[GetExcelTemplates]", e));
}
export function addNewExcelTemplate(data, fn) {
    return dispatch => {
        fetch(serverUrl + "api/ExcelTemplateAPI/AddNewTemplate", {
            headers: getheader(),
            method: "POST",
            body: JSON.stringify(data)
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "قالب جدید");
                    return;
                }
                setErrorDialog(dispatch, "success", "قالب جدید");
                if (fn) {
                    fn(res);
                }
            }).catch(e => console.log("[AddNewExcelTemplate]", e));
    }
}
export function ListenToEventSource(onMessage) {
    const register = (systemID) => {
        if (window.EventSource) {
            const source = new EventSource(serverUrl + `api/ServerEventsAPI/SubscribeToListener?SystemID=${systemID}`, {
                //withCredentials: true
            });
            source.onmessage = (e) => {
                onMessage(e.data);

            };
            source.onerror = (err) => {
                console.log(err);
            }
        }
    }
    const systemID = localStorage.getItem("SystemID");
    const token = localStorage.getItem("token");
    if (!systemID && token) {
        fetch(serverUrl + "api/ServerEventsAPI/GetSystemID", {
            headers: getheader()
        }).then(res => res.json())
            .then(res => {
                if (!res.ID) {
                    console.log("GET_SYSTEM_ID", "Error");
                    return;
                }
                localStorage.setItem("SystemID", res.ID);
                register(res.ID);
            })
    }
    else if (token) {
        register(systemID);
    }

}
function checkNotificationPromise() {
    try {
        Notification.requestPermission().then();
    } catch (e) {
        return false;
    }

    return true;
}
export function askNotificationPermission() {
    // function to actually ask the permissions
    function handlePermission(permission) {
        // set the button to shown or hidden, depending on what the user answers
        //notificationBtn.style.display =
        // Notification.permission === 'granted' ? 'none' : 'block';
    }

    // Let's check if the browser supports notifications
    if (!('Notification' in window)) {
        console.log("This browser does not support notifications.");
    } else if (checkNotificationPromise()) {
        Notification.requestPermission().then((permission) => {
            handlePermission(permission);
        });
    } else {
        Notification.requestPermission((permission) => {
            handlePermission(permission);
        });
    }
}
export function savePrintReport(reportName, reportJSON) {
    fetch(serverUrl + "api/PrintReportAPI/SaveReport/" + reportName, {
        headers: getheader(),
        body: JSON.stringify(reportJSON),
        method: "POST"
    }).then(res => res.json())
        .then(res => {
            if (res === "success")
                alert("فایل چاپ با موفقیت ذخیره شد");
            else {
                alert("اشکال در ذخیره فایل چاپ");
            }
        })
}
export function loadPrintReport(reportName, designMode, fn, tempUrl) {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Data-Type', 'json');
    if (!tempUrl) {
        myHeaders = getheader();
    }
    fetch((tempUrl ?? serverUrl) + `api/PrintReportAPI/LoadReport?reportName=${reportName}&designMode=${designMode}`, {
        headers: myHeaders,
        method: "GET"
    }).then(res => res.json())
        .then(res => {
            fn(res);
        })
}
export function loadPrintDataSource_get(url, fn, tempUrl) {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Data-Type', 'json');
    if (!tempUrl) {
        myHeaders = getheader();
    }
    return dispatch => {
        fetch((tempUrl ?? serverUrl) + url, {
            headers: myHeaders,
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "چاپ فرم");
                }
                else {
                    fn(res);
                }
            }).catch(e => console.log("[LOAD_PRINT_DATASOURCE_GET", e.Message));
    }
}
export function loadPrintDataSource_post(url, data, fn, tempUrl) {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Data-Type', 'json');
    if (!tempUrl) {
        myHeaders = getheader();
    }
    return dispatch => {
        fetch((tempUrl ?? serverUrl) + url, {
            headers: myHeaders,
            method: "POST",
            body: data
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "چاپ فرم");
                    console.log("[LOAD_PRINT_DATASOURCE_GET", res.Message);
                }
                else {
                    fn(res);
                }
            }).catch(e => console.log("[LOAD_PRINT_DATASOURCE_GET", e.Message));
    }
}
export function exportToExcel(fileName, searchData, fetchUrl, fetchMethod, tableColes, onDone) {
    const onGetData = (res) => {
        let exportData = [];
        res.forEach(data => {
            const d = {};
            tableColes.forEach(t => {
                if ((!t.showCondition || t.showCondition()) && t.colName !== "RowNumber")
                    d[t.colTitle] = data[t.colName]
            });
            exportData.push(d);
        });
        const workSheet = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, workSheet, "Data");
        writeFile(wb, fileName + ".xlsx", { compression: true });
        if (onDone) {
            onDone();
        }
    }
    if (fetchMethod === "get") {
        const qryString = Object.keys(searchData).map(key => key + '=' + searchData[key]).join('&');
        fetchUrl += "?" + qryString;
        fetch(serverUrl + fetchUrl, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    return;
                }
                if (res.Data) {
                    res = res.Data;
                }
                else if (res.Tasks) {
                    res = res.Tasks;
                }
                onGetData(res);

            }).catch(e => console.log("[EXPORT_TO_EXCEL]", e))
    }
    else if (fetchMethod === "post") {
        fetch(serverUrl + fetchUrl, {
            method: "POST",
            headers: getheader(),
            body: JSON.stringify(searchData)
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    return;
                }
                if (res.Data) {
                    res = res.Data;
                }
                else if (res.Tasks) {
                    res = res.Tasks;
                }
                if (res && Array.isArray(res)) {
                    onGetData(res);
                }

            }).catch(e => console.log("[EXPORT_TO_EXCEL]", e))
    }
}
export function getRemainedAccount(accountID, accountCat, onGetData) {
    onGetData("PENDING");
    fetch(serverUrl + `api/DocumentsAPI/GetRemainedAccount?accountID=${accountID}&accountCat=${accountCat}`, {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = -1;
            }
            onGetData(res);
        }).catch(e => {
            console.log("[GET_REMAINED_ACCOUNT]", e);
            onGetData(-1);
        })
}
export function keyIsLetterOrNumber(keyCode, key) {
    return ((keyCode >= 65 && keyCode <= 90) ||
        (keyCode >= 96 && keyCode <= 105) ||
        (keyCode >= 48 && keyCode <= 57) ||
        keyCode === 32 || key === 'ک' || key === 'گ' || key === 'چ' || key === 'ج' || key === "پ");
}
export function getMethodByDispatcher(url, actionType, cacheType, messageTitle) {

    let token = localStorage.getItem("token");
    let sUrl = localStorage.getItem("ServerUrl");
    if (token === null || sUrl === null) {
        return;
    }
    return dispatch => {
        dispatch({
            type: actionType,
            data: "PENDING"
        });
        fetch(sUrl + url, {
            headers: getheader(),
            cache: cacheType,
            method: "GET"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, messageTitle);
                    res = null;
                }
                dispatch({
                    type: actionType,
                    data: res
                })
            })
            .catch(e => {
                console.log(`[${actionType}]`, e);
                dispatch({
                    type: actionType,
                    data: null
                })
            })
    }
}
export function getMethodByCallBack(url, cacheType, onGetData, actionType) {
    let token = localStorage.getItem("token");
    let sUrl = localStorage.getItem("ServerUrl");
    if (token === null || sUrl === null) {
        return;
    }
    onGetData("PENDING");
    fetch(sUrl + url, {
        headers: getheader(),
        cache: cacheType,
        method: "GET"
    })
        .then(res => res.json())
        .then(res => {
            //For When Message Is One Of The Attributes Of The Response Object
            if (res.Message && Object.keys(res).length < 3) {
                res = { Error: translateError(res.Message) };
            }
            onGetData(res);
        })
        .catch(e => {
            console.log(`[${actionType}]`, e);
            onGetData({ Error: translateError(e.message) });
        })
}
export function postMethodByDispatcher(url, postData, actionType, messageTitle, onPostData) {
    let token = localStorage.getItem("token");
    let sUrl = localStorage.getItem("ServerUrl");
    if (token === null || sUrl === null) {
        return;
    }
    return dispatch => {
        dispatch({
            type: actionType,
            data: "PENDING"
        });
        fetch(sUrl + url, {
            headers: getheader(),
            method: "POST",
            body: JSON.stringify(postData)
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, messageTitle);
                    res = null;
                }
                if (actionType) {
                    dispatch({
                        type: actionType,
                        data: res
                    })
                }
                if (onPostData) {
                    onPostData(res);
                }
            })
            .catch(e => {
                console.log(`[${actionType}]`, e);
                if (actionType) {
                    dispatch({
                        type: actionType,
                        data: null
                    });
                }
            })
    }
}
export function postMethodByCallBack(url, postData, onPostData, actionType) {
    let token = localStorage.getItem("token");
    let sUrl = localStorage.getItem("ServerUrl");
    if (token === null || sUrl === null) {
        return;
    }
    fetch(sUrl + url, {
        headers: getheader(),
        method: "POST",
        body: JSON.stringify(postData)
    })
        .then(res => res.json())
        .then(res => {
            if (res.Message && res.Result != true) {
                res = { Error: translateError(res.Message) };
            }
            onPostData(res);
        })
        .catch(e => {
            console.log(`[${actionType}]`, e);
            onPostData({ Error: translateError(e.message) });
        })
}
export function sendSMS(smsData, onSend) {
    postMethodByCallBack("api/SMSAPI/SendSMS", smsData, onSend, "SEND_SMS");
}
export function sendSMS_Template(smsData, onSend) {
    postMethodByCallBack("api/SMSAPI/SendSMS_Template", smsData, onSend, "SEND_SMS_TEMPLATE");
}
export function networkManager_CheckIn(data, fn) {
    return dispatch => {
        const onPost = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "کنترل شبکه");
            }
            if (fn) {
                fn(res);
            }
        }
        postMethodByCallBack(`api/AccountApi/NetworkManager_CheckIn`, data, onPost, "NetworkManager_CheckIn");
    }
}
export function networkManager_CheckOut(data, onPost) {
    fetch(serverUrl + `api/AccountApi/NetworkManager_CheckOut`, {
        method: "POST",
        headers: getheader(),
        keepalive: true,
        body: JSON.stringify(data),
    })
    // postMethodByCallBack(`api/AccountApi/NetworkManager_CheckOut`,data, onPost, "NetworkManager_CheckOut");
}
export function isMobileApp() {
    return (window.innerWidth <= 414 || (window.innerHeight < 540));
    // return (window.innerWidth <= 430 || (window.innerHeight < 933));
}
export function isWebApp() {
     return (window.innerWidth > 414 && window.innerHeight >= 540);
    // return (window.innerWidth > 430 && window.innerHeight >= 933);
}
export function attachFile(fileInput, parentID, attachmentType, fn, moreInfo, nameIsUnique) {
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
        if (fn) {
            fn();
        }
        return;
    }
    var formdata = new FormData();
    for (let i = 0; i < fileInput.files.length; i++) {
        formdata.append(fileInput.files[i].name, fileInput.files[i]);
        formdata.append("ParentID", parentID);
        formdata.append("AttachmentType", attachmentType);
    }
    if (moreInfo) {
        formdata.append("moreInfo", moreInfo);
    }
    var xhr = new XMLHttpRequest();
    xhr.open('POST', serverUrl + 'api/Attachments/Upload', true);
    xhr.setRequestHeader("token", localStorage.getItem("token"));
    if (nameIsUnique) {
        xhr.setRequestHeader("NameIsUniq", nameIsUnique);
    }
    xhr.send(formdata);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            var response = JSON.parse(xhr.responseText);
            if (response.Message !== "Error") {
                alert("بارگذاری با موفقیت انجام شد");
                if (fn)
                    fn(response);
            }
            else {
                alert("اشکال در آپلود فایل");
            }

        }
        return "UnExpected Error";

    };
}
export function downloadFile(itemID, attachmentType, open) {
    fetch(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`,
        {
            headers: {
                'Content-Type': 'blob',
                'token': localStorage.getItem("token")
            },
            // WithCredentials: true,
            method: "get"
        })
        .then(async (response) => {
            const data = await response.blob();
            const contentDisp = response.headers.get('Content-Disposition');
            const fileName = contentDisp?.indexOf("filename=") > 0 ? contentDisp.substring(contentDisp.indexOf("filename=") + 9, contentDisp.length) : "Download";
            if (data.type === "application/json") {
                return;
            }
            let url = window.URL.createObjectURL(data);
            let extension = "";
            if (fileName.split('.').length > 1) {
                extension = fileName.split('.')[1];
            }
            if (open && (data.type.includes("image") || data.type.includes("pdf"))) {
                window.open(url, '_blank');
            }
            else {
                var a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                a.click();
            }
        }).catch(e => console.log(e.message));
}
// export function downloadFile(itemID, attachmentType, open) {
//     let fileName = "";
//     const save = (blob) => {
//         if (blob.type === "application/json") {
//             return;
//         }
//         let url = window.URL.createObjectURL(blob);
//         if (open && (blob.type.includes("image") || blob.type.includes("pdf"))) {
//             window.open(url, '_blank');
//         }
//         else {
//             var a = document.createElement("a");
//             a.href = url;
//             a.download = fileName;
//             a.click();
//         }

//     }
//     let xhr = new XMLHttpRequest();
//     xhr.open('GET', serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`, true);
//     xhr.setRequestHeader("token", localStorage.getItem("token"));
//     xhr.responseType = 'blob';
//     xhr.onload = e => save(xhr.response);
//     xhr.onreadystatechange = function () {
//         if (xhr.readyState === 4 && xhr.status === 200) {
//             const contentDisp = xhr.getResponseHeader('Content-Disposition');
//             fileName = contentDisp?.indexOf("filename=") > 0 ? contentDisp.substring(contentDisp.indexOf("filename=") + 9, contentDisp.length) : "Download";
//         }
//     }
//     xhr.send();
// }
export function deleteAttachment(id, type, onSuccess) {
    return dispatch => {
        fetch(serverUrl + `api/Attachments/DeleteAttachment?id=${id}&attachmentType=${type}`, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res === "Success") {
                    setErrorDialog(dispatch, "success", "حذف پیوست");
                    if (onSuccess) {
                        onSuccess();
                    }
                }
                else {
                    setErrorDialog(dispatch, "Error", "حذف پیوست");
                    return dispatch({
                        type: "DELETE_ATTACHMENT",
                        data: "ERROR"
                    });
                }
            }).catch(e => {
                console.log("[DELETE_ATTACHMENT]", e);
            })
    }
}
export function getAttachmentList(id, attachmentType, onGet) {
    getMethodByCallBack(`api/Attachments/GetAttachmentList?parentID=${id}&attachmentType=${attachmentType}`, cacheTypes.NoCache, onGet, "GetAttachmentList");
}
export function getImageServerPath(imageFullName, onGet) {
    getMethodByCallBack(`api/Attachments/GetImageServerPath?imageFullName=${imageFullName}`, cacheTypes.NoCache, onGet, "GET_IMAGE_PATH");
}
export function addNotice(data, onPost) {
    postMethodByCallBack("api/NoticeBoardAPI/AddNewNotice", data, onPost, "ADD_NEW_NOTICE");
}
export function getActiveSubsystems() {

    return dispatch => dispatch(getMethodByDispatcher("api/AccountApi/GetActiveSubSystems", "GET_ACTIVE_SUBSYSTEMS", cacheTypes.Default, ""));
}
export function addQuickAccess(data, onPost) {
    postMethodByCallBack(`api/UserAPI/AddQuickAccess`, data, onPost, "AddQuickAccess");
}
export function getCurrentUserQuickAccess(onGet) {
    getMethodByCallBack(`api/UserAPI/GetCurrentUserQuickAccess`, cacheTypes.NoCache, onGet, "GetCurrentUserQuickAccess");
}
export function deleteQuickAccess(pageUrl, onDelete) {
    getMethodByCallBack(`api/UserAPI/DeleteQuickAccess?pageUrl=${pageUrl}`, cacheTypes.NoCache, onDelete, "DeleteQuickAccess");
}
export function networkRelease(onDone) {
    getMethodByCallBack('api/AccountAPI/NetworkRelease', cacheTypes.NoCache, onDone, "NetworkRelease");
}
export function activeSerial(onDone) {
    getMethodByCallBack('api/SystemSetting/ActiveSerial', cacheTypes.NoCache, onDone, "ActiveSerial");
}
export function checkModule(modules, moduleCode) {
    return Number(modules) < 1 || bitwiseAnd(Number(modules), Number(moduleCode)) === Number(moduleCode);
}
function bitwiseAnd(firstNumber, secondNumber) {
    /*JavaScript Bitwise Operators Operate On 32 Bits At Most, But The Numbers We Have Considered For Modules Are Sometimes Larger Than 32 Bits. 
        So We Use This Function To Perform This Operation*/
    let // convert the numbers to binary strings
        firstBitArray = (firstNumber).toString(2),
        secondBitArray = (secondNumber).toString(2),
        resultedBitArray = [],
        // get the length of the largest number
        maxLength = Math.max(firstBitArray.length, secondBitArray.length);

    //add zero fill ahead in case the binary strings have different lengths
    //so we can have strings equal in length and compare bit by bit
    firstBitArray = firstBitArray.padStart(maxLength, '0');
    secondBitArray = secondBitArray.padStart(maxLength, '0');

    // bit by bit comparison
    for (let i = 0; i < maxLength; i++) {
        resultedBitArray.push(parseInt(firstBitArray[i]) && secondBitArray[i]);
    }

    //concat  the result array back to a string and parse the binary string back to an integer
    return parseInt(resultedBitArray.join(''), 2);
}
export function getDurationList(onGet) {
    getMethodByCallBack(`api/DurationAPI/GetDurationList`, cacheTypes.NoCache, onGet, "GetDurationList");
}
export function changeDuration(durationID, onGet) {
    getMethodByCallBack(`api/DurationAPI/ChangeCurrentDuration?durationID=${durationID}`, cacheTypes.NoCache, onGet, "ChangeCurrentDuration");
}
export function getCurrentDuration(onGet) {
    getMethodByCallBack(`api/DurationAPI/GetCurrentDuration`, cacheTypes.NoCache, onGet, "GetCurrentDuration");
}
export function getCurrentDurationName() {
    const durationName = localStorage.getItem("DurationName");
    if (durationName) {
        return "(دوره مالی فعال: " + durationName + ")";
    }
    return "";
}
export function enforceMinMax(e) {
    const el = e.target;
    if (el.value != "") {
      if (parseInt(el.value) < parseInt(el.min)) {
        el.value = el.min;
      }
      if (parseInt(el.value) > parseInt(el.max)) {
        el.value = el.max;
      }
    }
  }

